export default "__VITE_ASSET__6f4b3eaa__"